import React from "react";
import { ProgressBar, ProgressContainer, ProgressFill, Step, StepsContainer, StepWrapper, StyledContainer } from "./progress-bar.styles";

const steps = [
  "Contract details",
  "Upload documents",
  "Done",
];

const mapStep = (step: number) => {
  if (step === 1) return 1; // Step 1
  if (step === 2) return 2; // Step 2
  if (step === 3) return 3; // Step 3
  return 0;
};

const ProgressSteps: React.FC<{ currentStep: number }> = ({ currentStep }) => {
  // Apply the custom step mapping
  const adjustedStep = mapStep(currentStep);
  const progress = (adjustedStep / (steps.length - 1)) * 100;

  return (
    <StyledContainer>
      <ProgressContainer>
        <ProgressBar>
          <ProgressFill progress={progress} />
        </ProgressBar>
        <StepsContainer>
          {steps.map((step, index) => (
            <StepWrapper key={index}>
              <Step
                active={index <= adjustedStep}>
                {step}
              </Step>
            </StepWrapper>
          ))}
        </StepsContainer>
      </ProgressContainer>
    </StyledContainer>
  );
};

export default ProgressSteps;
